export default {
    CSV_TEMPLATE: 'https://firebasestorage.googleapis.com/v0/b/barcodeproject-2f250.appspot.com/o/template_files%2Fcsv_template.csv?alt=media&token=29ba7516-3ab0-45ef-91fd-3be08dbaf766'
}